import { ButtonDetailWarrantyComponent } from '@components/button/tables/warranty/button-modify-warranty.component';
import { ButtonDeleteWarrantyComponent } from '@components/button/tables/warranty/button-delete-warranty.component';

export class WarrantySettings {
  public static gridSettings() {
    return {
      actions: false,
      noDataMessage: 'Nessun dato trovato',
      attr: {
        class: 'table table-bordered',
      },
      pager: {
        display: true,
        perPage: 25,
      },
      columns: {
        detailButton: {
          type: 'custom',
          renderComponent: ButtonDetailWarrantyComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        deleteButton: {
          type: 'custom',
          renderComponent: ButtonDeleteWarrantyComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        id: {
          title: 'Id',
          width: '70px',
        },
        descrizione: {
          title: 'Descrizione',
        },
        enabled: {
          title: 'Abilitato',
          width: '130px',
          valuePrepareFunction: (abilitato) => {
            if (abilitato) {
              return 'Si';
            } else {
              return 'No';
            }
          },
          filter: {
            type: 'list',
            config: {
              list: [
                { value: true, title: 'Si' },
                { value: false, title: 'No' },
              ],
            },
          },
        },
      },
      delete: null,
    };
  }
}
